import type { GridProps } from '@cmg/design-system';
import { Grid, Stack } from '@cmg/design-system';
import type { ReactNode, VFC } from 'react';

export type IdentityPageContentProps = {
  /**
   * Local Highlights
   */
  localHighlights?: Readonly<ReactNode>;
  /**
   * Grid content
   */
  gridContent: Readonly<ReactNode>;

  slotProps?: {
    grid: GridProps;
  };
};

export const IdentityPageContent: VFC<IdentityPageContentProps> = ({
  localHighlights,
  gridContent,
  slotProps,
}) => {
  return (
    <Stack direction="column" flex={1}>
      {localHighlights}
      <Grid container px={4} spacing={3} {...slotProps?.grid}>
        {gridContent}
      </Grid>
    </Stack>
  );
};
